import Vue from 'vue'
import { ToastPlugin, ModalPlugin, VBToggle } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueQuill from 'vue-quill-editor'
import VueSweetalert2 from 'vue-sweetalert2'
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import ImageResize from 'quill-image-resize'
import { ImageDrop } from 'quill-image-drop-module'
import htmlEditButton from 'quill-html-edit-button'
import DatePicker from 'vue2-datepicker'

import {
  getDay, getMonth, getYear, compareDates,
} from './services/serviceDates'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

window.toastr = require('toastr')
window.moment = require('moment')

const UploadFile = {
  install() {
    Vue.prototype.$saveFiles = data => {
      if (data && data.length > 0) {
        const formData = new FormData()

        data.forEach((element, index) => {
          if (element && element.file) {
            formData.append(`files-${index}`, element.file)
          }
        })

        Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/files/save-file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
      }
    }
  },
}

const Export = {
  install() {
    Vue.prototype.$export = data => {
      Vue.prototype.$http.post(data.url, data.filters, {
        responseType: 'arraybuffer',
      }).then(response => {
        // Create a Blob from the received response data
        const blobData = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        // Create a URL for the blob data
        const blobUrl = window.URL.createObjectURL(blobData)

        // Create a link and initiate the download
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `${data.name}.xlsx`
        link.click()
        store.dispatch('modals/toggleExportLoading', false)
      }).catch(() => {
        store.dispatch('modals/toggleExportLoading', false)
      })
    }
  },
}

const { Quill } = VueQuill
Quill.prototype.getHtml = e => e.container.firstChild.innerHTML
const Block = Quill.import('blots/block')
Block.tagName = 'div'
Quill.register(Block)

// Resize image module
Quill.register('modules/imageResize', ImageResize)

// Image drop module
Quill.register('modules/imageDrop', ImageDrop)

// Show html button
Quill.register('modules/htmlEditButton', htmlEditButton)

Vue.use(UploadFile)
Vue.use(Export)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(VueToastr2)
Vue.use(ModalPlugin)

Vue.use(DatePicker)

Vue.use(getDay)
Vue.use(getMonth)
Vue.use(getYear)
Vue.use(compareDates)

Vue.use(VueQuill, {
  modules: {
    htmlEditButton: {},
    toolbar: [
      ['bold', 'italic', 'underline'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }, { header: 3 }],
      [{ list: 'ordered' }, { list: 'bullet' }],

      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['clean'],
      ['link', 'image'],
    ],
    imageResize: {
      displayStyles: {
        backgroundColor: 'black',
        border: 'none',
        color: 'white',
      },
      modules: ['Resize', 'DisplaySize', 'Toolbar'],
    },
  },
})
Vue.use(VueSweetalert2)
Vue.directive('b-toggle', VBToggle)
// Composition API
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
